AFRAME.registerSystem("camera-movement-detector", {
  schema: {
    posThreshold: { default: 0.025 },
    rotThreshold: { default: 10 }
  },

  init() {
    this.prevPos = new THREE.Vector3();
    this.prevQuat = new THREE.Quaternion();
    this.cameraObj = null;
    this.currentPos = new THREE.Vector3();
    this.currentQuat = new THREE.Quaternion();
  },

  update() {
    const camera = this.el.sceneEl.querySelector("#avatar-pov-node");
    this.cameraObj = camera ? camera.object3D : null;
  },

  tick(t, dt) {
    if (!this.cameraObj) {
      if (t % 1000 < dt) {
        const camera = this.el.sceneEl.querySelector("#avatar-pov-node");
        this.cameraObj = camera ? camera.object3D : null;
      }
      return;
    }

    this.cameraObj.getWorldPosition(this.currentPos);
    this.cameraObj.getWorldQuaternion(this.currentQuat);

    if (this.prevPos.lengthSq() === 0) {
      this.prevPos.copy(this.currentPos);
      this.prevQuat.copy(this.currentQuat);
      return;
    }

    const distance = this.currentPos.distanceTo(this.prevPos);
    const angle = this.prevQuat.angleTo(this.currentQuat) * (180 / Math.PI);

    if (distance > this.data.posThreshold) {
      this.el.sceneEl.emit("camera-movement-detected", { distance }, false);
    }

    if (angle > this.data.rotThreshold) {
      this.el.sceneEl.emit("camera-rotation-detected", { angle }, false);
    }

    this.prevPos.copy(this.currentPos);
    this.prevQuat.copy(this.currentQuat);
  }
});
